module.exports = __webpack_public_path__ + "static/media/NanumSquareB.e850eb66.ttf";